import { useEffect } from 'react';

import { storage } from '../utils/common';

import { useConfigStore } from '../store/useConfigStore';

const SOUND = 'el_promo_sound';

const useSound = () => {
	const sound = useConfigStore((s) => s.sound);
	const setSound = useConfigStore((s) => s.setSound);

	useEffect(() => {
		const stored = storage.get(SOUND);

		const value = stored ? JSON.parse(stored) : (sound ?? true);

		setSound(value);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [SOUND]);

	const toggle = () => {
		const next = !sound;

		setSound(next);

		storage.set(SOUND, JSON.stringify(next));
	};

	return {
		muted: sound,
		toggle,
	};
};

export default useSound;
